import Button, { Color } from 'lib/Button';
import Input from 'lib/Input';
import Modal from 'lib/Modal';
import removeSvg from 'assets/icons/remove.svg';
import restoreSvg from 'assets/icons/restore.svg';
import closeSvg from 'assets/icons/close.svg';
import { UsePreviewContentModals } from '../../hooks/usePreviewContentModals';
import { DELETE_CREATIVE_MODAL_TEXT, RESTORE_CREATIVE_MODAL_TEXT } from '../../consts';

type PreviewContentModalsProps = Omit<
  UsePreviewContentModals,
  'openRejectModal' | 'openDeleteModal' | 'openRestoreModal'
>;

const PreviewContentModals: React.FC<PreviewContentModalsProps> = ({
  rejectModal,
  restoreModal,
  deleteModal,
  updateRejectReason,
  rejectReason,
}) => {
  return (
    <>
      <Modal
        isOpen={rejectModal.show}
        icon={closeSvg}
        title="Reject Creative?"
        dataTestId="creative-reject-modal"
        iconStyles="text-pinkRed-500"
        actionButtons={
          <>
            <Button label="Cancel" onClick={rejectModal.close} />
            <Button color={Color.DANGER} onClick={rejectModal.onAction} isDisabled={!rejectReason} label="Reject" />
          </>
        }
      >
        <div className="w-96">
          <Input placeholder="Reject Reason…" value={rejectReason} onChange={updateRejectReason} />
        </div>
      </Modal>
      <Modal
        isOpen={deleteModal.show}
        icon={removeSvg}
        title="Delete Creative?"
        dataTestId="creative-delete-modal"
        iconStyles="text-pinkRed-500"
        actionButtons={
          <>
            <Button label="Cancel" onClick={deleteModal.close} />
            <Button label="Delete" color={Color.DANGER} onClick={deleteModal.onAction} />
          </>
        }
      >
        <p className="body-base text-neutral-950-opacity-60">{DELETE_CREATIVE_MODAL_TEXT}</p>
      </Modal>
      <Modal
        isOpen={restoreModal.show}
        icon={restoreSvg}
        title="Restore Creative?"
        dataTestId="creative-restore-modal"
        actionButtons={
          <>
            <Button onClick={restoreModal.close} label="Cancel" />
            <Button label="Restore" color={Color.DANGER} onClick={restoreModal.onAction} />
          </>
        }
      >
        <p className="body-base text-neutral-950-opacity-60">{RESTORE_CREATIVE_MODAL_TEXT}</p>
      </Modal>
    </>
  );
};
export default PreviewContentModals;
